import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/auth.service';

interface BusinessOwnerProtectedRouteProps {
  children: React.ReactNode;
}

const BusinessOwnerProtectedRoute: React.FC<BusinessOwnerProtectedRouteProps> = ({
  children,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isBusinessOwner, setIsBusinessOwner] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dashboardRoute, setDashboardRoute] = useState('/login');

  useEffect(() => {
    const checkAuth = async () => {
      const auth = await authService.isAuthenticated();
      setIsAuthenticated(auth);

      if (auth) {
        // Verifica se é BUSINESS_OWNER
        const businessOwner = await authService.isBusinessOwner();
        setIsBusinessOwner(businessOwner);
        const route = await authService.getDashboardRoute();
        setDashboardRoute(route);
      }

      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isBusinessOwner) {
    // Se não for BUSINESS_OWNER, redireciona para o dashboard adequado
    return <Navigate to={dashboardRoute} replace />;
  }

  return <>{children}</>;
};

export default BusinessOwnerProtectedRoute;
